import Big from 'big.js';
import { Metrics } from '../../hooks';
import {
  ContractTypeId,
  DeployContractPackageResult,
} from '@block-explorer/entities';

interface MetricsPercentages {
  apyPercent: number | null;
  eraTotalStakePercent: number | null;
  circulatingSupplyPercent: number | null;
}

export const filterSystemContracts = (
  contracts: DeployContractPackageResult[] | null
) =>
  contracts?.filter(
    (contract) =>
      contract.latest_version_contract_type_id !== ContractTypeId.System
  );

export const getMetricsPercentage = (metrics: Metrics): MetricsPercentages => {
  const networkVersion = metrics?.casperNetworkVersion;
  const annualStakingRewards =
    networkVersion?.indexOf('2.2.') >= 0
      ? metrics?.annualStakingRewardsIssuance
      : metrics?.annualIssuance;

  const apyPercent =
    metrics?.totalSupply == null ||
    metrics?.eraTotalStake == null ||
    metrics?.annualStakingRewardsIssuance == null
      ? null
      : Big(metrics.totalSupply)
          .mul(annualStakingRewards)
          .div(metrics.eraTotalStake)
          .mul(100)
          .toNumber();

  const eraTotalStakePercent =
    metrics?.totalSupply == null || metrics?.eraTotalStake == null
      ? null
      : Big(metrics.eraTotalStake).div(metrics.totalSupply).mul(100).toNumber();

  const circulatingSupplyPercent =
    metrics?.totalSupply == null || metrics?.circulatingSupply == null
      ? null
      : Big(metrics.circulatingSupply)
          .mul(100)
          .div(Big(metrics.totalSupply))
          .toNumber();

  return {
    apyPercent,
    eraTotalStakePercent,
    circulatingSupplyPercent,
  };
};
